"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countLines = exports.offsetToColRow = void 0;
/**
 * Convert offset at the given input to col/row location
 *
 * This function is not optimized and practically emulates via brute-force
 * the navigation on the terminal, wrapping when they reach the column width.
 */
function offsetToColRow(input, offset, maxCols) {
    var row = 0;
    var col = 0;
    for (var i = 0; i < offset; ++i) {
        var chr = input.charAt(i);
        if (chr === "\n") {
            col = 0;
            row += 1;
        }
        else {
            col += 1;
            if (col > maxCols) {
                col = 0;
                row += 1;
            }
        }
    }
    return { row: row, col: col };
}
exports.offsetToColRow = offsetToColRow;
/**
 * Counts the lines in the given input
 */
function countLines(input, maxCols) {
    return offsetToColRow(input, input.length, maxCols).row + 1;
}
exports.countLines = countLines;
